import validationUtils from './validationUtils';

const validate = (values: any) => {
  const errors: any = {};
  if (!validationUtils.isValidEmail(values.email)) {
    errors.email = 'Please enter a valid e-mail address';
  }
  if (typeof values.understoodTerms === 'boolean' && !values.understoodTerms) {
    errors.understoodTerms = 'Accepting the Policy is required for subscription';
  }
  return errors;
};

/**
 * Form Validation per Element
 */

const validateEmail = {
  required: 'This email field is required',
  validate: {
    validEmail: (value: string) => validationUtils.isValidEmail(value) || 'Please enter a valid e-mail address',
  },
};

const validateTerms = {
  required: 'Accepting the Policy is required for subscription',
};

/**
 * Namespaced Form Validation
 */

const validateForm = {
  email: validateEmail,
  understoodTerms: validateTerms,
};

/**
 * Exports
 */

export default validate;

export { validateForm };
